document.addEventListener('DOMContentLoaded', function() {
  // Function to filter, sort, and update the accordion state
  function filterAndSortFAQs() {
    // Step 1: Get the selected category's data-category value
    var selectedCategory = document.querySelector('.faq_category.selected');
    if (!selectedCategory) return;
    var selectedCategoryValue = selectedCategory.getAttribute('data-category');

    // Step 2: Select all FAQ items
    var faqItems = Array.from(document.querySelectorAll('.accordion_item.faq_question'));

    // Step 3: Filter FAQ items that match the selected category
    var filteredItems = faqItems.filter(function(item) {
      return item.getAttribute('data-blog') === selectedCategoryValue;
    });

    // Step 4: Sort items with 'hits:' tag by the value in descending order
    filteredItems.sort(function(a, b) {
      // Extract 'hits:' value from both items
      var hitsA = a.className.match(/hits:(\d+)/) ? parseInt(a.className.match(/hits:(\d+)/)[1], 10) : 0;
      var hitsB = b.className.match(/hits:(\d+)/) ? parseInt(b.className.match(/hits:(\d+)/)[1], 10) : 0;

      // Sort by hits in descending order
      return hitsB - hitsA;
    });

    // Step 5: Get the parent container to reorder the elements
    var parent = filteredItems[0] ? filteredItems[0].parentElement : null;

    // Step 6: Append sorted items back into the parent container
    if (parent) {
      // Hide all FAQ items
      faqItems.forEach(function(item) {
        item.style.display = 'none';
      });

      // Show the filtered and sorted FAQ items
      filteredItems.forEach(function(item) {
        item.style.display = 'block';
        parent.appendChild(item); // Reorder items in the DOM
      });

      // Step 7: Close all opened accordions and update the 'collapsed' class on the links
      var allAccordions = document.querySelectorAll('.collapse');
      allAccordions.forEach(function(accordion) {
        // Close the accordion
        accordion.classList.remove('show');
        accordion.setAttribute('aria-expanded', 'false');
        
        // Find the link and add the 'collapsed' class
        var link = accordion.previousElementSibling;
        if (link && link.classList.contains('faq_question_title')) {
          link.classList.add('collapsed');
        }
      });

      // Step 8: Open the first accordion in the filtered items
      var firstAccordion = filteredItems[0].querySelector('.collapse');
      if (firstAccordion) {
        firstAccordion.classList.add('show');
        firstAccordion.setAttribute('aria-expanded', 'true');
        
        // Find the link and remove the 'collapsed' class
        var firstLink = firstAccordion.previousElementSibling;
        if (firstLink && firstLink.classList.contains('faq_question_title')) {
          firstLink.classList.remove('collapsed');
        }
      }
    }
  }

  // Call filterAndSortFAQs when the page is loaded
  filterAndSortFAQs();

  // Add event listeners to each category to trigger re-filtering and re-sorting when a category is selected
  var categories = document.querySelectorAll('.faq_category');
  categories.forEach(function(category) {
    category.addEventListener('click', function() {
      // Remove the "selected" class from the previously selected category
      document.querySelector('.faq_category.selected').classList.remove('selected');
      
      // Add the "selected" class to the clicked category
      category.classList.add('selected');

      // Re-filter and re-sort FAQs
      filterAndSortFAQs();
    });
  });
});

function initializeNestedSliders($this) {
  const $clickedBox = jQuery($this).closest(".plan_option_box");
  const data_handle = $clickedBox.attr("data-collection-handle");
  const isActive = $clickedBox.hasClass("active");

  $(".plan_option_box").removeClass("active");
  jQuery('.main_rich_text .rich_text_box').hide();
  $("#planDataAppend").empty();
  if (jQuery($this).find(".data_plans_slider").hasClass("slick-initialized")) {
    jQuery($this).find(".data_plans_slider").slick("unslick");
  }

  if (!isActive) {
    $clickedBox.addClass("active");
    jQuery('.main_rich_text .rich_text_box.'+data_handle).show();
    jQuery($this).find(".data_plans_slider").css("visibility", "visible");
    const $mainDataBox = $clickedBox.find(".main_data_plans_box");
    if ($mainDataBox.length) {
      const $clonedBox = $mainDataBox.clone();
      $("#planDataAppend").append($clonedBox);
      scrollToElement(jQuery("#planDataAppend")[0]);
      equalizeUlHeights($("#planDataAppend"));
      equalizePromoHeights('#planDataAppend');

      $clonedBox.find(".data_plans_slider").slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        speed: 1000,
        dots: true,
        arrows: true,
        prevArrow:
          '<button type="button" class="slick-arrow slick-prev"></button>',
        nextArrow:
          '<button type="button" class="slick-arrow slick-next"></button>',
        rows: 0,
        autoplay: false,
        autoplaySpeed: 3000,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }
  }else{
    jQuery('.main_rich_text .rich_text_box:first-child').show();
  }
}

function equalizeUlHeights(parentSelector) {
    var $uls = jQuery(parentSelector).find('.data_plan_fetaures ul');
    if ($uls.length === 0) return;
    // Reset heights before measuring
    $uls.css('height', 'auto');
    var maxHeight = 0;
    $uls.each(function() {
        var height = jQuery(this).outerHeight();
        
        if (height > maxHeight) {
            maxHeight = height;
        }
    });
    $uls.height(maxHeight);
}

function equalizePromoHeights(parentSelector) {
  var $promos = jQuery(parentSelector).find('.data_plan_promo');
  if ($promos.length === 0) return;

  // Reset heights before measurement
  $promos.css('height', 'auto');

  var maxHeight = 0;

  $promos.each(function () {
    var height = jQuery(this).outerHeight();
    if (height > maxHeight) {
      maxHeight = height;
    }
  });

  // Apply the maximum height to all promo elements
  $promos.height(maxHeight);
}


function initializePlanOptionsJS() {
  const window_size = window.innerWidth;
 
  // Clean up existing instances
  if ($(".plan_options_slider").hasClass("slick-initialized")) {
    $(".plan_options_slider").slick("unslick");
  }
 
  $(".plan_option_box").removeClass("active");
  $("#planDataAppend").empty();
  $(".main_data_plans_box").removeAttr("style");
 
  if (window_size >= 576) {
    jQuery(".plan_options_slider").slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      speed: 1000,
      dots: true,
      arrows: true,
      prevArrow:
        '<button type="button" class="slick-arrow slick-prev plan_options_prev"></button>',
      nextArrow:
        '<button type="button" class="slick-arrow slick-next plan_options_next"></button>',
      rows: 0,
      autoplay: false,
      autoplaySpeed: 5000,
      responsive: [
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    // Open collection grid using handle start
    var pathParts = window.location.pathname.split('/');
    var currentHandle = '';
    var fz_flag = false;

    if (pathParts.includes('collections')) {
      var index = pathParts.indexOf('collections');
      currentHandle = pathParts[index + 1];
      var fz_flag = true;
    }

    /* Slide First */
    var slider_index = jQuery('[data-collection-handle="'+currentHandle+'"]').parents('.slick-slide').attr('data-slick-index');
    if( slider_index ){
      jQuery('.plan_options_slider').slick('slickGoTo', parseInt(slider_index));
    }else{
      // jQuery('.plan_options_slider [data-slick-index="0"] .plan_option_box').click();
    }
    
    $(".plan_option_box").off("click").on("click", function (event) {
      var handle = jQuery(this).attr('data-collection-handle');
      var pathParts = window.location.pathname.split('/');
      var currentHandle = '';
      if (pathParts.includes('collections')) {
        history.pushState({}, "", "/collections/" + handle);
      }
      if (window.innerWidth >= 576) {
        initializeNestedSliders(jQuery(this));
      }
    });
 
    $(".plan_options_slider").on("afterChange", function () {
      $(".plan_option_box").removeClass("active");
      $("#planDataAppend").empty();
      if( fz_flag ){
        jQuery('[data-slick-index="'+slider_index+'"] [data-collection-handle="'+currentHandle+'"]').click();
        jQuery('[data-collection-handle="'+currentHandle+'"]').addClass('active');
        fz_flag = false;
      }
    });
 
    $(".plan_options_slider .plan_options_prev, .plan_options_slider .plan_options_next").on("click", function () {
      $(".plan_option_box").removeClass("active");
      if ($("#planDataAppend .data_plans_slider").length > 0 && $("#planDataAppend .data_plans_slider").hasClass("slick-initialized")) {
        $("#planDataAppend .data_plans_slider").slick("unslick");
      }
      $("#planDataAppend").empty();
    });
  } else {
    $(".plan_options_slider .main_data_plans_box").hide();
 
    $(".plan_options_slider .plan_option_title_wp, .plan_options_slider .plan_option_box_text").off("click").on("click", function (j) {
      if (window.innerWidth <= 576) {
      var $this = $(this).parents('.plan_option_box');
      var dropDown = $this.closest("div").find(".main_data_plans_box");
      var dataPlansSlider = dropDown.find(".data_plans_slider");
      var data_handle = $this.attr("data-collection-handle");

      $this.closest(".plan_options_slider").find(".main_data_plans_box").not(dropDown).slideUp();
      jQuery('.main_rich_text .rich_text_box').hide();
        
      if( data_handle ){
        jQuery('.main_rich_text .rich_text_box.' + data_handle).show();
      }else{
        jQuery('.main_rich_text .rich_text_box:first-child').show();
      }
 
      if ($this.hasClass("active")) {
        $this.removeClass("active");
      } else {
        $this.closest(".plan_options_slider").find(".active").removeClass("active");
        $this.addClass("active");
      }
 
      dataPlansSlider.css("visibility", "hidden");
      dropDown.stop(false, true).slideToggle(function () {
        if (dropDown.is(":visible")) {
          dataPlansSlider.css("visibility", "visible");
 
          var offsetTop = $this.find('.data_plan_box').offset().top - 80;
          $("html, body").animate({ scrollTop: offsetTop }, 100);
          equalizeUlHeights(dataPlansSlider);
          if (!dataPlansSlider.hasClass("slick-initialized")) {
            dataPlansSlider.slick({
              infinite: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              speed: 1000,
              dots: true,
              arrows: true,
              prevArrow:
                '<button type="button" class="slick-arrow slick-prev"></button>',
              nextArrow:
                '<button type="button" class="slick-arrow slick-next"></button>',
              rows: 0,
              autoplay: false,
              autoplaySpeed: 3000,
            });
          } else {
            dataPlansSlider.slick("setPosition");
          }
        }
      });
      j.preventDefault();
    }
    });

    // Open collection grid using handle start
    var pathParts = window.location.pathname.split('/');
    var currentHandle = '';

    if (pathParts.includes('collections')) {
      var index = pathParts.indexOf('collections');
      currentHandle = pathParts[index + 1];
      jQuery('[data-collection-handle="'+currentHandle+'"] .plan_option_box_text').click();
    }
    
    // $(".main_data_plans_box").off("click").on("click", function (e) {
    //   e.stopPropagation();
    // });
  }
  if( fz_flag && slider_index == 0 ){
    jQuery('[data-slick-index="'+slider_index+'"] [data-collection-handle="'+currentHandle+'"]').click();
    jQuery('[data-collection-handle="'+currentHandle+'"]').addClass('active');
    fz_flag = false;
  }
}

function bindSeeInclusionsClick() {
  // Use event delegation to make it safe for dynamic content
  jQuery('body').off('click', '.see_inclusions_title').on('click', '.see_inclusions_title', function() {
    jQuery(this).closest('.see_inclusions').find('.see_inclusions_content').slideToggle();
    jQuery(this).toggleClass('active');
  });
}
// Call on load
$(document).ready(function () {
  initializePlanOptionsJS();
  bindSeeInclusionsClick();
  jQuery('.pi_wrapper .rich_text_box').hide();
  jQuery('.pi_wrapper .rich_text_box:first-child').show();
  equalizePromoHeights(jQuery('.cs-promo-box'));
});
 
// Call on resize (debounced for performance)
let resizeTimeout;
let currentWindowWidth = window.innerWidth;
$(window).on("resize", function () {
  equalizePromoHeights(jQuery('.cs-promo-box'));
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(function () {
    const newWindowWidth = window.innerWidth;
    // Only re-initialize if crossing the breakpoint
    if ((currentWindowWidth < 576 && newWindowWidth >= 576) || (currentWindowWidth >= 576 && newWindowWidth < 576)) {
      initializePlanOptionsJS();
      // Wait to rebind collapsible elements
      setTimeout(() => {
        bindSeeInclusionsClick();
      }, 100);
    }
    currentWindowWidth = newWindowWidth;
  }, 300);
});

document.addEventListener("DOMContentLoaded", function () {
  const modal_stepButtons = document.querySelectorAll(`.modal__light.modal .step-item[rel*="_first"] .modal_btns .theme_btn`);
  modal_stepButtons.forEach((btn) => {
    btn.addEventListener("click", function (event) {
      const btn_link = this.getAttribute("href");
      if (btn_link.startsWith("#")) {
        event.preventDefault();
        const modal_wrapper = this.closest(".modal-step-wrapper");
        if (!modal_wrapper) return;

        // Hide the first step
        const modal_firstStep = modal_wrapper.querySelector('.step-item[rel*="_first"]');
        if (modal_firstStep) {
          modal_firstStep.classList.remove("active");
        }
        const modal_secondStep = modal_wrapper.querySelector('.step-item[rel*="_second"]');
        if (modal_secondStep) {
          modal_secondStep.classList.add("active");
        }
      }
    });
  });

  document.querySelector('.modal__light.modal .modal-header .step-back').addEventListener("click", function (event) {
    event.preventDefault();
    const modal_wrapper = this.closest(".modal-step-wrapper");
    if (!modal_wrapper) return;

    const firstStep = modal_wrapper.querySelector('.step-item[rel*="_first"]');
    const secondStep = modal_wrapper.querySelector('.step-item[rel*="_second"]');
    if (secondStep) secondStep.classList.remove("active");
    if (firstStep) firstStep.classList.add("active");
  });

  function updateModalHeights(modal) {
    const scrollableBoxes = modal.querySelectorAll(".modal-scrollable-content-box");
    scrollableBoxes.forEach((box) => {
      const modal_header = box.previousElementSibling;
      const modal_footer = box.nextElementSibling;

      const headerHeight = modal_header ? modal_header.offsetHeight : 0;
      const footerHeight = modal_footer ? modal_footer.offsetHeight : 0;

      const maxHeight = window.innerHeight - 30 - headerHeight - footerHeight;
      box.style.maxHeight = `${maxHeight}px`;
    });
  }
  document.querySelectorAll('.modal__light:not(.qualifying_modal)').forEach((modal) => {
    $(document).on('shown.bs.modal', modal, function (e) {
      updateModalHeights(modal);
    });

    window.addEventListener('resize', () => {
      if (modal.classList.contains('show')) {
        updateModalHeights(modal);
      }
    });
  });
    function resetModalSteps(modal) {
    const modalWrapper = modal.querySelector('.modal-step-wrapper');
    if (!modalWrapper) return;

    // Reset the steps: remove active from all and add it to the first
    const steps = modalWrapper.querySelectorAll('.step-item');
    steps.forEach(step => step.classList.remove('active'));

    const firstStep = modalWrapper.querySelector('.step-item[rel*="_first"]');
    if (firstStep) {
      firstStep.classList.add('active');

      // Reset button text for the first step
      const activeOption = firstStep.querySelector('.qualifying-option.active');
      const textWrapper = firstStep.querySelector('.qualifying-text-wrapper');

      if (activeOption) {
        updateButtonText(activeOption);
      } else if (textWrapper) {
        updateButtonText(textWrapper);
      }
    }
  }

  // Bind the reset function to modal close event
  $(document).on('hidden.bs.modal', '.modal__light', function (e) {
    resetModalSteps(this);
  })

  // PDP Buy Now Sticky Start
  const buy_block = document.querySelector(".main_product_details .button_group");
  if (!buy_block) return;

  const highlightText = document.querySelector('.main_product_details .highlight_text');
  if (highlightText) {
    const stickyContainer = document.querySelector('.main_product .sticky_button_bar .sticky__info');
    if (stickyContainer) {
      const clone = highlightText.cloneNode(true);
      stickyContainer.append(clone);
    }
  }




  function isFullyVisible(el) {
    const r = el.getBoundingClientRect();
    return r.top >= 0 && r.bottom <= window.innerHeight;
  }
  function isPartiallyVisible(el) {
    const r = el.getBoundingClientRect();
    return r.top < window.innerHeight && r.bottom > 0;
  }
  function toggleSticky() {
    if (isFullyVisible(buy_block)) {
      document.body.classList.remove('show_sticky');
    } else if (isPartiallyVisible(buy_block)) {
      document.body.classList.add('show_sticky');
    } else {
      document.body.classList.add('show_sticky');
    }
  }
  toggleSticky();
  window.addEventListener("scroll", toggleSticky);
  window.addEventListener("resize", toggleSticky);
  // PDP Buy Now Sticky End
});